<template>
  <div class="share-copy__container">
    <CopyLink />
    <ShareToEmail />
  </div>
</template>

<script setup lang="ts">
import CopyLink from './CopyLink.vue';
import ShareToEmail from './ShareToEmail.vue';
import { useContentStore } from '../../foundation/stores/contentStore';

const contentStore = useContentStore();

// Trigger the population of the shareCopy data in the content store. Will invoke a GQL call to populate if shareCopy is empty.
contentStore.fetchShareCopy();
</script>

<style lang="scss" scoped>
.share-copy__container {
  display: flex;
  gap: 33px;
  height: 33px;
  position: relative;
  margin: 1rem 0;

  @media screen and (min-width: #{$breakpoint-xl}) {
    margin: 2rem 0;
  }

  .share-copy__text {
    display: flex;
    background-repeat: no-repeat;
    font-size: 1rem;
    color: $racq-dark-grey;
    cursor: pointer;
    line-height: 33px;
    background-position: 0px;

    &:hover {
      color: $racq-blue;
    }
  }
}
</style>
